import { FETCH_COMPETENCY_ASSESSMENT_REQUEST } from '../actions/competency.action';

// Global flag to prevent race conditions
let isFetching = false;
let fetchPromise: Promise<any> | null = null;

/**
 * Middleware to prevent duplicate competency assessment fetches
 * This ensures that even if multiple FETCH_COMPETENCY_ASSESSMENT_REQUEST
 * actions are dispatched simultaneously, only one will proceed
 */
const competencyFetchLockMiddleware = (store: any) => (next: any) => (action: any) => {
  if (action.type === FETCH_COMPETENCY_ASSESSMENT_REQUEST) {
    // If already fetching, skip this request
    if (isFetching) {
      console.log('🔒 Fetch lock active - skipping duplicate request');
      return fetchPromise; // Return existing promise
    }
    
    // Set lock
    isFetching = true;
    console.log('🔓 Fetch lock acquired');
    
    // Proceed with the action
    const result = next(action);
    
    // Create a promise that will resolve when fetch completes
    fetchPromise = new Promise((resolve) => {
      // Release lock after a short delay to allow the async thunk to complete
      setTimeout(() => {
        isFetching = false;
        fetchPromise = null;
        console.log('🔓 Fetch lock released');
        resolve(result);
      }, 100);
    });
    
    return result;
  }
  
  return next(action);
};

export default competencyFetchLockMiddleware;
